import { useEffect, useState } from "react";
import { useRouter } from "next/router";

export function useHash() {
  const router = useRouter();

  const [hash, setHash] = useState<string>();
  useEffect(() => {
    function onHashChangeStart(url: string) {
      setHash(url.split("#")[1]);
    }

    // Fire once to update on mount
    onHashChangeStart(window.location.href);

    router.events.on("hashChangeStart", onHashChangeStart);
    return () => {
      router.events.off("hashChangeStart", onHashChangeStart);
    };
  }, [router.events]);

  return hash;
}
